<template>
  <div class="w-full h-full flex items-center">
    <div class="absolute won-tag-light-gray h-full" :style="{ 'width': rulerPaddings.leftPadding  + 'px' }" />
    <div class="absolute won-tag-light-gray right-0 h-full" :style="{ 'width': rulerPaddings.rightPadding  + 'px' }" />
    
    <div class="w-full flex flex-row select-none relative">
        <div v-for="k in 8" style="width: 12.5%" class="flex flex-row items-center justify-between h-full relative" :key="`${k}_ruler`" :id="`${k}_ruler`">
          <div v-for="item in 8" :key="`${item}_subruler`" style="width: 12.5%" :class="{'h-[3px] border-r ': item < 8 && item !== 4, 'h-[7px] border-r': item === 8 && item !== 4, 'h-[3px] border-0': item === 4}" class="border-[#ACADAE]" />
          <div v-show="showNumbers" class="absolute mx-auto w-max left-0 right-0 text-[10px] leading-[12px] text-[#073B5D]" v-html="k" />
        </div>
    </div>
  </div>
</template>

<script setup>
  import { useBuilderStyles } from '../../store/builder-style.store'
  import { ref, watch } from 'vue'
  import { storeToRefs } from 'pinia'

  const builderStyle = useBuilderStyles()
  const { zoom, getRullerPaddings: rulerPaddings  } = storeToRefs(builderStyle)
  const showNumbers = ref(true)

  watch(zoom, (newZoom) => {
    showNumbers.value = newZoom > 50
  })
</script>